"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InkCompileResult = exports.InkSourceFile = exports.InkSourceLine = exports.InkCompileMessage = exports.InkMessageLevel = void 0;
const zod_1 = require("zod");
exports.InkMessageLevel = zod_1.z.enum(['warning', 'error', 'todo']);
exports.InkCompileMessage = zod_1.z.object({
    type: exports.InkMessageLevel.optional(),
    file: zod_1.z.string().optional(),
    lineNumber: zod_1.z.number().int().optional(),
    message: zod_1.z.string(),
    blockId: zod_1.z.string().optional(),
});
exports.InkSourceLine = zod_1.z.object({
    id: zod_1.z.string(),
    text: zod_1.z.string(),
    lineNumber: zod_1.z.number().int(),
});
exports.InkSourceFile = zod_1.z.object({
    scriptId: zod_1.z.string(),
    name: zod_1.z.string(),
    loadError: zod_1.z.string().optional(),
    isInk: zod_1.z.boolean().optional(),
    blockLines: zod_1.z.array(exports.InkSourceLine),
});
exports.InkCompileResult = zod_1.z.object({
    inkJson: zod_1.z.string().nullable(),
    messages: zod_1.z.array(exports.InkCompileMessage),
});
